import { EventHandler } from '@n7-frontend/core';

export class CompareFilterDropdownEH extends EventHandler {
  public listen() {

    this.innerEvents$.subscribe(event => {
      switch(event.type){

        case 'compare-filter-dropdown.clickOut':
          this.dataSource.onClickOut(event);
          break;

        default:
          break;
      }
    });
  }
}
